<template>
    <Card :title="$t('labels.new_custom_field')">
        <form @submit.prevent="create">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-6">
                        <FormGroup :label="$t('labels.name')" required>
                            <Input
                                v-model="customField.title"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-6">
                        <FormGroup :label="$t('labels.type')">
                            <AppSelect
                                @update:model-value="type = $event"
                                :model-value="type.key"
                                :selected-value="type.value"
                                :options="customFieldsOptions"
                                option-key="key"
                                option-value="value"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-12">
                        <FormGroup :label="$t('labels.description')">
                            <Input
                                v-model="customField.description"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-12" v-if="type.key === CustomFieldTypes.SELECT">
                        <FormGroup :label="$t('labels.select_items')">
                            <Tags
                                v-model="selectItems"
                                @keydown.enter.prevent
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-12">
                        <FormGroup :label="$t('labels.default_value')">
                            <Input
                                v-if="type.key === CustomFieldTypes.STRING"
                                v-model="customField.default_value"
                            />
                            <Input
                                v-else-if="type.key === CustomFieldTypes.LINK"
                                v-model="customField.default_value"
                                placeholder="https://example.com"
                            />
                            <Input
                                v-else-if="type.key === CustomFieldTypes.NUMBER"
                                v-model="customField.default_value"
                                type="number"
                            />
                            <textarea
                                v-else-if="type.key === CustomFieldTypes.LONG_TEXT"
                                v-model="customField.default_value"
                                class="form-control"
                            />
                            <Checkbox
                                v-else-if="type.key === CustomFieldTypes.CHECKBOX"
                                v-model="customField.default_value"
                            />
                            <AppSelect
                                v-else-if="type.key === CustomFieldTypes.SELECT"
                                :model-value="customField.default_value"
                                :selected-value="customField.default_value"
                                @update:model-value="customField.default_value = $event.value"
                                :options="selectOptions"
                                option-key="value"
                                option-value="value"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-12">
                        <FormGroup :label="$t('labels.required')">
                            <Checkbox v-model="customField.required" />
                        </FormGroup>
                    </div>
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
                <AppButton color="indigo" type="submit">
                    <i class="icon-floppy-disk mr-2"></i>
                    {{ $t('buttons.create') }}
                </AppButton>
            </div>
        </form>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import AppButton from "../../../../components/new/button/AppButton.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import AppSelect from "../../../../components/new/form/select/AppSelect.vue";
import Tags from "../../../../components/new/form/Tags.vue";
import Checkbox from "../../../../components/new/form/checkbox/AppCheckbox.vue";

import { CustomFieldTypes } from "../../../enums/CustomFieldTypesEnum";
import { CustomFieldApi } from "../../../api/CustomFieldApi";

export default {
    name: 'CustomFieldCreatePage',
    components: {
        Card, AppButton, FormGroup, Input, AppSelect, Tags, Checkbox
    },
    data() {
        return {
            CustomFieldTypes,
            customFieldsOptions: [],
            type: {
                key: 'string',
                value: this.$t(`enum.custom_field.type.string`)
            },
            selectItems: '',
            customField: {
                title: '',
                description: '',
                default_value: '',
                required: false
            }
        }
    },
    computed: {
        selectOptions() {
            return this.selectItems
                .split(',')
                .map(item => item.trim())
                .filter(Boolean)
                .map(item => ({ value: item }));
        }
    },
    methods: {
        async create() {
            let items = this.type.key === this.CustomFieldTypes.SELECT
                ? this.selectItems.split(',').map(item => item.trim()).filter(Boolean)
                : [];

            await CustomFieldApi.create(this.$route.params.projectUuid, {
                model: 'product-item',
                type: this.type.key,
                title: this.customField.title,
                description: this.customField.description,
                required: Boolean(this.customField.required),
                default_value: this.type.key === this.CustomFieldTypes.CHECKBOX && this.customField.default_value === ''
                    ? false
                    : this.customField.default_value,
                additional: { items }
            });

            this.$router.push({ name: 'CustomFieldsIndexPage' });
        }
    },
    watch: {
        'type.key'() {
            this.customField.default_value = '';
        }
    },
    mounted() {
        this.customFieldsOptions = Object.entries(this.CustomFieldTypes).map(([key, value]) => ({
            key: value,
            value: this.$t(`enum.custom_field.type.${value}`)
        }));
    }
}
</script>
